var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 117,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 36.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 58,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 59l-16.5 9.526V49.474L69 59z",
    fill: "#387"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTciIGhlaWdodD0iMTE3IiB2aWV3Qm94PSIwIDAgMTE3IDExNyIgZmlsbD0ibm9uZSI+CiAgICA8Y2lyY2xlIGN4PSI1OC41IiBjeT0iNTguNSIgcj0iMzYuNSIgZmlsbD0id2hpdGUiLz4KICAgIDxjaXJjbGUgY3g9IjU4LjUiIGN5PSI1OC41IiByPSI1OCIgc3Ryb2tlPSJ3aGl0ZSIvPgogICAgPHBhdGggZD0iTTY5IDU5TDUyLjUgNjguNTI2M0w1Mi41IDQ5LjQ3MzdMNjkgNTlaIiBmaWxsPSIjMzM4ODc3Ii8+Cjwvc3ZnPg==";
export { SvgVideoIcon2 as ReactComponent };